import {useContext} from 'react';

import {getVisibleAppendixPageConfigs} from './appendixPageConfig';
import {AppendixPageSlot} from './AppendixPageSlot';
import {CulturePillarAppendixPage} from './CulturePillarAppendixPage';
import {CultureAnalysisPdfContext} from '../../../../contexts/CultureAnalysisPdfContext/CultureAnalysisPdfContext';

export const AppendixPages = () => {
  const {data, loading} = useContext(CultureAnalysisPdfContext);

  if (loading || !data) {
    return null;
  }

  const visibleConfigs = getVisibleAppendixPageConfigs(data.cultureHouse);

  return (
    <>
      {visibleConfigs.map((config, index) => (
        <AppendixPageSlot
          key={`${config.pillarKey}-${config.pagePart ?? config.startIndex ?? 0}-${index}`}
          hasFollowingPage={index < visibleConfigs.length - 1}
        >
          <CulturePillarAppendixPage {...config} />
        </AppendixPageSlot>
      ))}
    </>
  );
};
